export default {
  rateDescription: {
    id: 'review_display_rate_description',
    defaultMessage: `{totalReviews, number} {totalReviews, plural,
      one {purchase}
      other {purchases}
    } in the last 6 months.`,
  },
}
